import * as React from "react"
import { useMemo, useContext } from "react"
import parse from "html-react-parser"
import { PageContext } from "../context/pageProvider"

const createRgb = color => {
  if (color) {
    const { r, g, b } = color.rgb
    return `${r}, ${g}, ${b}`
  }
  return null
}

const createSiteUrl = () =>
  process.env.NODE_ENV === "production"
    ? process.env.SITE_URL
    : `${process.env.SITE_URL.split(".").join("")}.addictive.cloud`

function fontUrl(string) {
  return string?.split(" ").join("+")
}

function Seo({ children, seo }) {
  const pageContext = useContext(PageContext)
  const { primaryColor, secondaryColor, font, gsv, area } =
    pageContext.meta.settings
  const { contentData, content, pageType } = pageContext.page

  let currentTitle = useMemo(() => {
    let data = ""
    try {
      if (contentData) {
        data = parse(contentData)
      }
      if (pageType === "contact") {
        return "Kontakta oss"
      }
      let newTitle = ""
      if (data.length && Array.isArray(data)) {
        let headerData =
          data.find(tag => tag.type === "h1") ||
          data.find(tag => tag.type === "h2")
        newTitle = headerData.props.children.type
          ? headerData.props.children.props.children
          : headerData.props.children
      }
      if (!newTitle.length && content) {
        content.map(item => {
          const result =
            item.content.find(text => text.style === "h1") ||
            item.content.find(text => text.style === "h2")
          if (result) {
            newTitle = result.children[0].text
          }
        })
      }
      if (!newTitle.length) {
        newTitle = "Title"
      }

      return newTitle
    } catch (err) {
      console.log(err)
      return "Title"
    }
  }, [contentData, content])

  const newGsv = parse(`${gsv}`)

  const widgetCode = parse(`${area}`)

  return (
    <>
      {<title>{currentTitle}</title>}
      {area && widgetCode}
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin />
      <link
        href={`https://fonts.googleapis.com/css2?family=${
          font ? fontUrl(font) : "Lora"
        }:ital,wght@0,400;0,600;1,400;1,600&display=block`}
        rel="stylesheet"
      />
      <style>
        {`
        :root {
          --primary: ${createRgb(primaryColor)};
          --secondary: ${createRgb(secondaryColor)}
        }
          body {
            font-family: ${font || "Lora"};
          }`}
      </style>
      {newGsv}
      <meta name="description" content={seo?.description} />
      <meta name="author" content={seo?.author} />
      <meta property="og:site_name" content={createSiteUrl()} />
      <meta property="og:title" content={currentTitle} />
      <meta property="og:description" content={seo?.description} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content={seo?.lang} />
      <meta property="og:url" content={createSiteUrl()} />
      <meta
        property="og:image"
        content={`${createSiteUrl()}/favicon-32x32.png`}
      />
      <meta property="og:image:alt" content={currentTitle} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:creator" content="Vitalii Yeremenko" />
      <meta name="twitter:title" content={currentTitle} />
      <meta name="twitter:description" content={seo?.description} />
      <meta
        name="twitter:image"
        content={`${createSiteUrl()}/favicon-32x32.png`}
      />
      <meta name="twitter:site" content={createSiteUrl()} />
      {children}
    </>
  )
}

export default Seo
